// Last-resort copy for the App Router error boundaries. The primary message
// comes from the beErrSystemError content token; these hardcoded strings are
// shown ONLY when the token pipeline is itself unavailable — a total content
// outage on the in-provider boundaries, or always on the provider-less root
// boundary, which has no Apollo client to fetch with. (The two button labels
// have no token on this release line, so they always come from here.)
//
// Hardcoding here is the sanctioned exception to the content-token rule: the
// content service is one of the systems that may have failed, so a booking
// error screen can't depend on it to render its own message. Matches the
// sentence main's BE last-resort surfaces use, so the two lines read the same.
export const FALLBACK_HEADING = "Something went wrong";
export const FALLBACK_MESSAGE = "A system error has occurred. Please try again.";
export const FALLBACK_TRY_AGAIN = "Try again";
export const FALLBACK_START_OVER = "Start over";
